import cn from 'classnames';

import Subheading from 'components/common/Subheading';

/**
 * Header component for sign-up funnel pages.
 * Renders an optional title and subtitle with support for custom styling.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.title] - The main heading content.
 * @param {React.ReactNode} [props.subtitle] - Secondary text displayed below the title.
 * @param {boolean} [props.isCentered=false] - Centers the title and subtitle when true.
 * @param {string} [props.titleClassName=''] - Additional CSS classes for the title element.
 * @param {string} [props.subtitleClassName=''] - Additional CSS classes for the subtitle element.
 * @param {string} [props.containerClassName=''] - Additional CSS classes for the wrapper div.
 * @returns {React.ReactElement}
 */
const FunnelHeader = ({
  title,
  subtitle,
  isCentered = false,
  titleClassName = '',
  subtitleClassName = '',
  containerClassName = '',
}) => {
  return (
    <div className={cn(containerClassName)}>
      {title && (
        <h1
          className={cn(
            'display-text text-secondary bp1:h1',
            { 'text-center': isCentered, 'text-left': !isCentered },
            titleClassName
          )}
        >
          {title}
        </h1>
      )}
      {subtitle && (
        <Subheading
          className={cn(
            'text text-secondary pt-3',
            { 'text-center': isCentered, 'text-left': !isCentered },
            subtitleClassName
          )}
        >
          {subtitle}
        </Subheading>
      )}
    </div>
  );
};

FunnelHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  isCentered: PropTypes.bool,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default FunnelHeader;
